import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useHttp from '../../hooks/http.hook';
import FullScreenLoadingSpinner from './components/FullScreenLoadingSpinner';
import '../business/Business.css';

function getPromotionEditKind(promotion) {
  const conditions = Array.isArray(promotion?.conditions) ? promotion.conditions : [];

  const cond = conditions[0] || null;
  const typeId = cond?.typeId ?? cond?.type_id ?? null;

  // no conditions => discount list
  if (!typeId && conditions.length === 0) return 'discount';

  if (typeId === 3) return 'promo-code';
  if (typeId === 1) return 'conditional-discount';
  if (typeId === 2) return 'combined-discount';

  return 'discount';
}

export default function EditPromotionPage() {
  const navigate = useNavigate();
  const { promotionId } = useParams();
  const { requestWithMeta } = useHttp();

  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    (async () => {
      try {
        const res = await requestWithMeta(`/operator/promotions/${encodeURIComponent(promotionId)}`, 'GET');
        if (cancelled) return;
        if (!res?.ok) {
          setError(res?.data?.error || res?.data?.message || 'Не удалось загрузить акцию');
          return;
        }

        const kind = getPromotionEditKind(res?.data);
        navigate(`/promotions/${promotionId}/edit/${kind}`, { replace: true });
      } catch (e) {
        if (!cancelled) setError(e?.message || 'Ошибка загрузки');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [promotionId, requestWithMeta, navigate]);

  if (loading) {
    return <FullScreenLoadingSpinner />;
  }

  if (error) {
    return <div style={{ padding: 16, color: 'var(--theme-danger)' }}>{error}</div>;
  }

  return null;
}

